import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const PopularBets = loadable(() => pMinDelay(import('./PopularBets'), 300), {
  fallback: <Loading />
});

const AsyncPopularBets = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent?.device?.type } bg-green`,
      },
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <PopularBets { ...props } />
    </ApplicationLayout>
  );
};

AsyncPopularBets.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncPopularBets;
